var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showComponent && _vm.enabled)?_c('button',{staticClass:"btn btn-link btn-sm",staticStyle:{"text-decoration":"none"},attrs:{"title":"Install ERPeach"},on:{"click":function($event){$event.preventDefault();return _vm.install.apply(null, arguments)}}},[_c('i',{staticClass:"fa fa-download"})]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }